module.exports = __webpack_public_path__ + "img/0Q3A5798_L_Wood_MockedUp.48ff3e74.jpg";